<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getSuratJalanDeliverys"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-surat-jalan-number" label-cols-sm="4" label-cols-lg="3" label="Surat Jalan Number" label-for="filter-surat-jalan-number" size="sm" :model.sync="filter.suratJalanNumber" />
					<app-input-combobox-autocomplete :options="deliveryInstructions" optionsLabel="diNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Delivery Instruction" id="filter-" size="sm" :model.sync="filter.deliveryInstructionId" @input="getDeliveryInstructions" @focus="getDeliveryInstructions" />
					<app-input-datepicker-range  id="fieldset-delivery-date" label-cols-sm="4" label-cols-lg="3" label="Delivery Date" size="sm" :modelFrom.sync="filter.deliveryDateFrom" :modelTo.sync="filter.deliveryDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Customer" id="filter-" size="sm" :model.sync="filter.customerId" @input="getCustomers" @focus="getCustomers" />
					<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Destination" id="filter-" size="sm" :model.sync="filter.destinationId" @input="getCustomers" @focus="getCustomers" />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getSuratJalanDeliverys"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Surat Jalan Delivery</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown v-if="false" text="Action" class="m-md-2 btn-action-more" size="sm">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/suratjalandelivery/SuratJalanDelivery.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button v-if="true" class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
					
					<b-overlay v-if="false"
							   :show="isDeleteBusy"
							   rounded
							   opacity="0.6"
							   spinner-small
							   spinner-variant="primary"
							   class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-suratjalandelivery" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="suratJalanDeliverys" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="suratJalanDeliverys.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
				<b-th stacked-heading="Surat Jalan Number" class="table-filter">
					<b-form-input id="input-surat-jalan-number-table" @input="getSuratJalanDeliverysWithoutLoading" v-model="filter.suratJalanNumber" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Delivery Instruction" class="table-filter">
					<v-select append-to-body label="diNumber" :options="deliveryInstructions" :value="filter.deliveryInstructionId" :reduce="item => item.id" v-model="filter.deliveryInstructionId" :filterable="true" @input="getSuratJalanDeliverysWithoutLoading" @search="getDeliveryInstructions"></v-select>
				</b-th>
				<b-th stacked-heading="Delivery Date" class="table-filter">
					<b-form-datepicker boundary="viewport" placeholder="" id="input-delivery-date-from-table" reset-button @input="getSuratJalanDeliverysWithoutLoading" v-model="filter.deliveryDateFrom" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
					<b-form-datepicker boundary="viewport" placeholder="" id="input-delivery-date-to-table" reset-button @input="getSuratJalanDeliverysWithoutLoading" v-model="filter.deliveryDateTo" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
				</b-th>
				<b-th stacked-heading="Apakah Sudah Dikirim?">
					<v-select append-to-body label="name" :options="yesNoCombo" :value="filter.isAlreadyDeliver" :reduce="item => item.id" v-model="filter.isAlreadyDeliver" :filterable="true" @input="getSuratJalanDeliverysWithoutLoading" ></v-select>
				</b-th>
				<b-th stacked-heading="Customer" class="table-filter">
					<v-select append-to-body label="code" :options="customers" :value="filter.customerId" :reduce="item => item.id" v-model="filter.customerId" :filterable="true" @input="getSuratJalanDeliverysWithoutLoading" @search="getCustomers"></v-select>
				</b-th>
				<b-th stacked-heading="Destination" class="table-filter">
					<v-select append-to-body label="code" :options="customers" :value="filter.destinationId" :reduce="item => item.id" v-model="filter.destinationId" :filterable="true" @input="getSuratJalanDeliverysWithoutLoading" @search="getCustomers"></v-select>
				</b-th>
				<b-th stacked-heading="Remarks" class="table-filter">
					<b-form-input id="input-remarks-table" @input="getSuratJalanDeliverysWithoutLoading" v-model="filter.remarks" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Driver Name" class="table-filter">
					<b-form-input id="input-driver-name-table" @input="getSuratJalanDeliverysWithoutLoading" v-model="filter.driverName" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Vehicle Number" class="table-filter">
					<b-form-input id="input-vehicle-number-table" @input="getSuratJalanDeliverysWithoutLoading" v-model="filter.vehicleNumber" size="sm"></b-form-input>
				</b-th>

						<b-th stacked-heading="Select All">
							<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox>
						</b-th>
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(suratjalannumber)="row">

                <a @click="() => ( $router.push({ name: 'suratjalandeliverydetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.suratJalanNumber != null && row.item.suratJalanNumber != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.suratJalanNumber.slice(0, 30) + (row.item.suratJalanNumber.length > 30 ? "..." : "" ) : row.item.suratJalanNumber : "" }}
						</a>
            
					</template>

			<template v-slot:cell(deliveryInstruction)="row">
				{{ row.item.deliveryInstruction != null ? row.item.deliveryInstruction.diNumber : "" }}
			</template>
			<template v-slot:cell(deliveryDate)="row">
				{{ row.item.deliveryDate | moment("DD-MMM-YYYY") }}
			</template>
			<template v-slot:cell(customer)="row">
				{{ row.item.customer != null ? row.item.customer.code : "" }}
			</template>
			<template v-slot:cell(destination)="row">
				{{ row.item.destination != null ? row.item.destination.code : "" }}
			</template>
				<template v-slot:cell(remarks)="row">
					<app-long-text  :id="'remarks-' + row.index" :text="row.item != null ? (row.item.remarks != null && row.item.remarks != '' ? row.item.remarks : '') : ''" />
				</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2" v-if="false">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-datepicker  id="fieldset-delivery-date" label-cols-lg="12"  label="Delivery Date" size="sm" :model.sync="row.item.deliveryDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.customerId" label="Customer" :selected="row.item.customer != null ? row.item.customer.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.destinationId" label="Destination" :selected="row.item.destination != null ? row.item.destination.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-textarea id="fieldset-remarks" label-cols-lg="12"  label="Remarks" label-for="input-remarks" size="sm" :model.sync="row.item.remarks"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-driver-name" label-cols-lg="12"  label="Driver Name" label-for="input-driver-name" size="sm" :model.sync="row.item.driverName"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-vehicle-number" label-cols-lg="12"  label="Vehicle Number" label-for="input-vehicle-number" size="sm" :model.sync="row.item.vehicleNumber"   :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(suratJalanDeliverysPaging != null ? suratJalanDeliverysPaging.dataCount : 0)"
									:per-page="(suratJalanDeliverysPaging != null ? suratJalanDeliverysPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-suratjalandelivery.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

	::v-deep #table-list-suratjalandelivery.b-table>thead>tr>th {
		background: #e28b29;
	}

    ::v-deep #table-list-suratjalandelivery.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import SuratJalanDelivery from '@/models/SuratJalanDelivery/SuratJalanDelivery';
import SuratJalanDeliveryList from '@/models/SuratJalanDelivery/SuratJalanDeliveryList';
import SuratJalanDeliveryFilter from '@/filters/SuratJalanDelivery/SuratJalanDeliveryFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import DeliveryInstructionFilter from '@/filters/DeliveryInstruction/DeliveryInstructionFilter';
import DeliveryInstruction from '@/models/DeliveryInstruction/DeliveryInstruction';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import CustomerFilter from '@/filters/Customer/CustomerFilter';
import Customer from '@/models/Customer/Customer';
import AppInputTextbox from '@/components/AppInputTextbox';
import DeliveryInstructionDeliveryCardFilter from '@/filters/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCardFilter';
import DeliveryInstructionDeliveryCard from '@/models/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCard';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		SuratJalanDelivery, 
		SuratJalanDeliveryList, 
		SuratJalanDeliveryFilter, 
		AppLabel,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextarea,
		AppInputTextbox,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"suratJalanNumber": {}, "class" : "th-surat-jalan-number first-child", "label" : "Surat Jalan Number", key: 'suratJalanNumber', sortable: true}, 
				{"deliveryInstruction": {}, "class" : "th-delivery-instruction", "label" : "Delivery Instruction", key: 'deliveryInstruction', sortable: true}, 
				{"deliveryDate": {}, "class" : "th-delivery-date last-child", "label" : "Delivery Date", key: 'deliveryDate', sortable: true}, 
				{"isAlreadyDeliver": {}, "class" : "th-is-already-deliver d-stack-none", "label" : "Apakah Sudah Dikirim?", key: 'isAlreadyDeliver', sortable: true}, 
				{"customer": {}, "class" : "th-customer d-stack-none", "label" : "Customer", key: 'customer', sortable: true}, 
				{"destination": {}, "class" : "th-destination d-stack-none", "label" : "Destination", key: 'destination', sortable: true}, 
				{"remarks": {}, "class" : "th-remarks d-stack-none", "label" : "Remarks", key: 'remarks', sortable: true}, 
				{"driverName": {}, "class" : "th-driver-name d-stack-none", "label" : "Driver Name", key: 'driverName', sortable: true}, 
				{"vehicleNumber": {}, "class" : "th-vehicle-number d-stack-none", "label" : "Vehicle Number", key: 'vehicleNumber', sortable: true}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			suratJalanDeliverys: [],
			suratJalanDeliverysPaging: {},
			deliveryInstructions : [],
			customers : [],
			suratJalanDeliveryDetails : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
			
		}
	},	methods : {
		getSuratJalanDeliverys : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			SuratJalanDelivery.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.suratJalanDeliverys = result.data
					this.suratJalanDeliverysPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getSuratJalanDeliverysWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			SuratJalanDelivery.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.suratJalanDeliverys = result.data
					this.suratJalanDeliverysPaging = result
				}
			})
			.catch(error => {});
		},
		getDeliveryInstructions : async function(input) {
			let filter = new DeliveryInstructionFilter();
			if (input != undefined) {
				filter.diNumber = input;
			}
			await DeliveryInstruction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructions = result.data
				}
			})
			.catch(error => {});
		},
		getCustomers : async function(input) {
			let filter = new CustomerFilter();
			if (input != undefined) {
				filter.code = input;
			}
			await Customer.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.customers = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new SuratJalanDeliveryFilter();
			this.getSuratJalanDeliverys();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getSuratJalanDeliverys();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				SuratJalanDelivery.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			SuratJalanDelivery.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			SuratJalanDelivery.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},
		createData() {
			this.isCreateBusy = true;
			SuratJalanDelivery.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'suratjalandeliveryedit';
						if(this.isScannerMode) {
							createRoute = 'suratjalandeliveryscan';
						}

						this.$router.push({ name: createRoute, params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			SuratJalanDelivery.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'suratjalandeliveryedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			SuratJalanDelivery.deleteData(this, id).then(result => {
				if (result)
				{
					this.getSuratJalanDeliverys();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				SuratJalanDelivery.deleteMultipleData(this).then(result => {
					this.getSuratJalanDeliverys();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableSuratJalanDeliveryParent = document.getElementById('table-list-suratjalandelivery').parentNode;
			tableSuratJalanDeliveryParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableSuratJalanDeliveryParent.scrollWidth - tableSuratJalanDeliveryParent.offsetWidth) == Math.ceil(tableSuratJalanDeliveryParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableSuratJalanDeliveryParent = document.getElementById('table-list-suratjalandelivery').parentNode;
			tableSuratJalanDeliveryParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableSuratJalanDeliveryParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new SuratJalanDeliveryFilter();
		this.getDeliveryInstructions()
		this.getCustomers()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Surat Jalan Delivery"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getSuratJalanDeliverys();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getSuratJalanDeliverys();
			}
		},
		sortDesc: {
			handler: function() {
				this.getSuratJalanDeliverys();
			}
		},
		currentPage: {
			handler: function() {
				this.getSuratJalanDeliverys();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getSuratJalanDeliverys();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				SuratJalanDelivery.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "suratjalandeliveryindex") {
					this.getSuratJalanDeliverysWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "surat_jalan_delivery").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
